import React, { useState } from 'react';
import { Input, Select } from 'antd';
import Wifi from './wifi';
import Ethernet from './ethernet';

export default function Internet() {
    const { Option } = Select;

    const [value, setValue] = useState('WiFi')

    function handleChange(value: any) {
        setValue(value)
    }


    return (
        <React.Fragment>
            <div className='mt-8 py-2'>
                <Select defaultValue={value} style={{ width: '100%', textAlign: 'left' }} onChange={handleChange}>
                    <Option className="text-left" value="WiFi">WiFi</Option>
                    <Option className="text-left" value="Ethernet">Ethernet</Option>
                </Select>
            </div>
            {
                value === 'WiFi' ? (<Wifi />) : (<Ethernet />)
            }
        </React.Fragment>
    );
}
